import Vue from 'vue';
import SessionStorage from 'vue-sessionstorage';

Vue.use(SessionStorage);